import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'subscription.checkout.payment.label': {
    id: 'subscription.checkout.payment.label',
    defaultMessage: 'Subscription payment details.',
    description: 'Section heading for subscription payment details.',
  },
});

export default messages;
